/* Phase */
export const phaseAdd = (phase) => ({
  type: 'PHASE_ADD',
  phase
});

export const phaseRemove = () => ({
  type: 'PHASE_REMOVE'
});
